<template>
    <div>
        <div
            :class="{ 'is-grey': isGrey, 'is-active': show }"
            class="product-tab"
            @click="toggle"
        >
            <slot
                name="click-area"
            />
        </div>

        <div v-if="show">
            <slot
                name="toggle-area"
            />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            isGrey: {
                required: false,
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                show: false,
            };
        },
        methods: {
            toggle() {
                this.show = !this.show;
            },
        },
    };
</script>